export default {
  name: 'wisk-watch',
  width: 35,
  height: 35,
  paths: [
    { d: 'M17.5,35A17.5,17.5,0,1,1,35.0005,17.5005,17.52,17.52,0,0,1,17.5,35Zm0-32.7914A15.2914,15.2914,0,1,0,32.7919,17.5005,15.31,15.31,0,0,0,17.5,2.2086Z' },
    { d: 'M13.8538,13.0294A1.4583,1.4583,0,0,1,16.121,11.816l6.7062,4.4709a1.4582,1.4582,0,0,1,0,2.4268L16.121,23.1846a1.4583,1.4583,0,0,1-2.2672-1.2135Z' }
  ]
}
